/* ADG Studio — Our Work grid: category tabs and "Show all".
 * Every card is in the HTML, so without JS the whole portfolio shows.
 * Tabs read and write ?category=<slug> so old category links and the
 * menu's Licensing item land on the right filter.
 *
 * Even grid (2026-10-17, manager review): every card the same size, 3
 * across (2 under 991px, 1 under 601px), as many as the CSS says in --c.
 * "All work" shows the first N full rows, then everything on one click; a
 * category tab shows all of its projects. When the last row is short it is
 * centred: each card spans two half-columns (assets/adg-studio.css), so the
 * first card of that row starts one half-column per missing card in.
 * No wide cards (they made uneven rows). */
(function () {
  function colsOf(grid) {
    var c = parseInt(getComputedStyle(grid).getPropertyValue('--c'), 10);
    return c > 0 ? c : 1;
  }
  document.querySelectorAll('[data-adg-st-projects]').forEach(function (root) {
    var grid = root.querySelector('.adg-st-projects__grid');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-adg-st-card]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-adg-st-tab]'));
    var more = root.querySelector('[data-adg-st-more]');
    var status = root.querySelector('[data-adg-st-status]');
    var rowsCollapsed = parseInt(root.getAttribute('data-rows') || '4', 10) || 4;
    var current = '';
    var expanded = false;

    function matches(card) {
      return !current || (' ' + card.getAttribute('data-cats') + ' ').indexOf(' ' + current + ' ') !== -1;
    }
    function render(focusFirstNew) {
      var cols = colsOf(grid);
      var visible = cards.filter(matches);
      cards.forEach(function (c) { c.hidden = true; c.style.gridColumn = ''; });
      // All work, collapsed: the first rowsCollapsed full rows
      var limit = visible.length;
      if (!current && !expanded) limit = Math.min(visible.length, rowsCollapsed * cols);
      var firstNew = null;
      visible.forEach(function (c, i) {
        if (i < limit) {
          if (focusFirstNew && c.hidden && !firstNew && i >= focusFirstNew) firstNew = c;
          c.hidden = false;
        }
      });
      // centre a short last row: start it (cols - left over) half-columns in
      var rest = limit % cols;
      if (cols > 1 && rest) visible[limit - rest].style.gridColumn = (cols - rest + 1) + ' / span 2';
      if (more) {
        more.hidden = limit >= visible.length;
        more.textContent = 'Show all ' + visible.length + ' projects';
      }
      if (status) {
        var tab = tabs.filter(function (t) { return t.getAttribute('data-adg-st-tab') === current; })[0];
        var label = current && tab ? tab.getAttribute('data-label') : '';
        status.textContent = visible.length + (visible.length === 1 ? ' project' : ' projects') + (label ? ' in ' + label : '');
      }
      if (firstNew) { var a = firstNew.querySelector('a'); if (a) a.focus(); }
      root.setAttribute('data-shown', String(limit));
    }
    function select(slug, push) {
      current = slug;
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-adg-st-tab') === slug ? 'true' : 'false'); });
      render(0);
      if (push && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        if (slug) u.searchParams.set('category', slug); else u.searchParams.delete('category');
        history.replaceState(null, '', u.toString());
      }
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { select(t.getAttribute('data-adg-st-tab'), true); });
    });
    if (more) more.addEventListener('click', function () {
      var shownBefore = parseInt(root.getAttribute('data-shown') || '0', 10);
      expanded = true;
      render(shownBefore);
    });
    var lastCols = colsOf(grid), timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { var c = colsOf(grid); if (c !== lastCols) { lastCols = c; render(0); } }, 150);
    });

    var want = '';
    try { want = new URL(window.location.href).searchParams.get('category') || ''; } catch (e) {}
    var known = tabs.some(function (t) { return t.getAttribute('data-adg-st-tab') === want; });
    select(known ? want : '', false);
  });
})();

/* Project header backdrop (layouts Split and Hero, 2026-10-18): read the
 * colour of the art's own edge from a 48 px copy of the file (Shopify's CDN
 * allows it: Access-Control-Allow-Origin *). When the edge is one colour
 * (a logo on white, a poster with a cream border) the backdrop takes that
 * colour, so the art seems to fill its panel; otherwise the paper tone
 * stays. Nothing here touches the art itself. */
(function () {
  document.querySelectorAll('[data-adg-st-backdrop][data-sample]').forEach(function (box) {
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var w = 32, h = Math.max(4, Math.round(32 * probe.naturalHeight / probe.naturalWidth));
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var g = c.getContext('2d'); g.drawImage(probe, 0, 0, w, h);
        var d = g.getImageData(0, 0, w, h).data, px = [];
        // a ring one sample in from the edge: a hairline frame in the file
        // (the Fat Bottom logo has a grey 1 px line down its right side)
        // must not decide the colour
        for (var x = 1; x < w - 1; x++) { px.push((w + x) * 4, ((h - 2) * w + x) * 4); }
        for (var y = 2; y < h - 2; y++) { px.push((y * w + 1) * 4, (y * w + w - 2) * 4); }
        var sum = [0, 0, 0], n = px.length;
        px.forEach(function (i) { sum[0] += d[i]; sum[1] += d[i + 1]; sum[2] += d[i + 2]; });
        var m = sum.map(function (v) { return v / n; }), off = 0;
        px.forEach(function (i) { off += Math.abs(d[i] - m[0]) + Math.abs(d[i + 1] - m[1]) + Math.abs(d[i + 2] - m[2]); });
        off = off / n / 3;
        if (off < 10) {
          box.style.setProperty('--adg-st-bd', 'rgb(' + m.map(Math.round).join(',') + ')');
          box.setAttribute('data-adg-st-bd', 'matched');
        } else {
          box.setAttribute('data-adg-st-bd', 'paper');
        }
      } catch (e) { box.setAttribute('data-adg-st-bd', 'paper'); }
    };
    probe.src = box.getAttribute('data-sample');
  });
})();

